/* ============================================================
   NATIVA · Concept A — theme.js (vanilla, no deps)
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var cfg = (window.NATIVA && window.NATIVA.anim) || { enabled: true, reveal: true };
  var S = (window.NATIVA && window.NATIVA.strings) || {};
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover:hover) and (pointer:fine)').matches;
  function money(c) {
    var f = (window.NATIVA && window.NATIVA.moneyFormat) || '{{amount}} EGP';
    return f.replace(/\{\{\s*amount\s*\}\}/, (c / 100).toLocaleString(undefined, { minimumFractionDigits: 0 }));
  }

  /* ---------- sticky header ---------- */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('stuck', scrollY > 24); };
    addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- custom cursor + magnetic ---------- */
  if (fine && cfg.enabled && !reduce) {
    var dot = document.createElement('div'); dot.className = 'cursor-dot';
    var ring = document.createElement('div'); ring.className = 'cursor-ring';
    document.body.appendChild(dot); document.body.appendChild(ring);
    var mx = innerWidth / 2, my = innerHeight / 2, rx = mx, ry = my;
    addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px'; dot.style.top = my + 'px';
    });
    (function loop() { rx += (mx - rx) * .18; ry += (my - ry) * .18; ring.style.left = rx + 'px'; ring.style.top = ry + 'px'; requestAnimationFrame(loop); })();
    var hoverSel = 'a,button,input,select,textarea,summary,.pcard,.catcard,[data-magnetic]';
    document.addEventListener('mouseover', function (e) { if (e.target.closest(hoverSel)) document.body.classList.add('cursor-hover'); });
    document.addEventListener('mouseout', function (e) { if (e.target.closest(hoverSel)) document.body.classList.remove('cursor-hover'); });

    $$('[data-magnetic]').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * .25, y = (e.clientY - r.top - r.height / 2) * .35;
        el.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- reveal on scroll ---------- */
  if (cfg.enabled && cfg.reveal && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: .14 });
    $$('.reveal, .draw').forEach(function (el) { io.observe(el); });
    window.NATIVA_bindReveal = function (root) { (root || document).querySelectorAll('.reveal:not(.in), .draw:not(.in)').forEach(function (el) { io.observe(el); }); };
  } else {
    $$('.reveal, .draw').forEach(function (el) { el.classList.add('in'); });
    window.NATIVA_bindReveal = function (root) { (root || document).querySelectorAll('.reveal, .draw').forEach(function (el) { el.classList.add('in'); }); };
  }

  /* ---------- mobile menu ---------- */
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { var m = $('#m-nav'); if (m) { m.classList.add('open'); document.body.style.overflow = 'hidden'; } }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { var m = $('#m-nav'); if (m) { m.classList.remove('open'); document.body.style.overflow = ''; } }); });

  /* ---------- hero slider ---------- */
  $$('[data-slider]').forEach(function (slider) {
    var slides = $$('.slide', slider);
    if (slides.length < 1) return;
    var dots = $$('[data-slide-dot]', slider);
    var i = 0, timer = null;
    var interval = parseInt(slider.getAttribute('data-autoplay'), 10) || 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
    }
    $$('[data-slide-next]', slider).forEach(function (b) { b.addEventListener('click', function () { go(i + 1); rest(); }); });
    $$('[data-slide-prev]', slider).forEach(function (b) { b.addEventListener('click', function () { go(i - 1); rest(); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); rest(); }); });
    function start() { if (interval > 0 && !reduce) timer = setInterval(function () { go(i + 1); }, interval); }
    function rest() { clearInterval(timer); start(); }
    go(0); start();
    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', start);
  });

  /* ============================================================
     CART (Shopify AJAX)
     ============================================================ */
  var overlay = $('#overlay'), drawer = $('#cart-drawer');
  function openCart() { overlay && overlay.classList.add('open'); drawer && drawer.classList.add('open'); drawer && drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeCart() { overlay && overlay.classList.remove('open'); drawer && drawer.classList.remove('open'); drawer && drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); refresh(); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  overlay && overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('open')) { closeCart(); return; }
    var mnav = $('#m-nav');
    if (mnav && mnav.classList.contains('open')) { mnav.classList.remove('open'); document.body.style.overflow = ''; }
  });

  function render(cart) {
    var wrap = $('#cart-items'); if (!wrap) return;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    var sub = $('#cart-subtotal'); if (sub) sub.textContent = money(cart.total_price);
    var foot = $('#cart-foot'); if (foot) foot.hidden = cart.item_count === 0;
    if (!cart.items.length) { wrap.innerHTML = '<div class="cart-empty">' + (S.cartEmpty || 'Your cart is empty.') + '<br><a class="btn btn--ghost" style="margin-top:1rem" href="/collections/all" data-cart-close>' + (S.startShopping || 'Start shopping') + '</a></div>'; bindClose(); return; }
    wrap.innerHTML = cart.items.map(function (it) {
      return '<div class="cline" data-key="' + it.key + '">' +
        '<img src="' + (it.image ? it.image.replace(/(\.[^.]+)(\?|$)/, '_120x$1$2') : '') + '" alt="" loading="lazy">' +
        '<div><a href="' + it.url + '" style="font-family:var(--head);font-weight:500">' + it.product_title + '</a>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="muted" style="font-size:.82rem">' + it.variant_title + '</div>' : '') +
        '<div class="qty" style="margin-top:.5rem;transform:scale(.82);transform-origin:left"><button data-dn>−</button><input value="' + it.quantity + '" data-in inputmode="numeric" aria-label="' + (S.quantity || 'Quantity') + '"><button data-up>+</button></div></div>' +
        '<div style="text-align:end"><div style="font-weight:600">' + money(it.final_line_price) + '</div>' +
        '<button data-rm style="color:var(--muted);font-size:.78rem;text-decoration:underline;margin-top:.4rem">' + (S.remove || 'Remove') + '</button></div></div>';
    }).join('');
    bindLines(); bindClose();
  }
  function bindClose() { $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); }); }
  function bindLines() {
    $$('.cline').forEach(function (line) {
      var key = line.getAttribute('data-key'), input = $('[data-in]', line);
      var chg = function (q) { update(key, Math.max(0, q)); };
      $('[data-up]', line).addEventListener('click', function () { chg(+input.value + 1); });
      $('[data-dn]', line).addEventListener('click', function () { chg(+input.value - 1); });
      input.addEventListener('change', function () { chg(+input.value || 0); });
      $('[data-rm]', line).addEventListener('click', function () { chg(0); });
    });
  }
  function refresh() { fetch('/cart.js').then(function (r) { return r.json(); }).then(render).catch(function () {}); }
  function update(key, q) { fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) }).then(function (r) { return r.json(); }).then(render).catch(function () {}); }
  window.NATIVA_add = function (id, qty, cb) {
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: qty || 1 }) })
      .then(function (r) { return r.json(); }).then(function () { refresh(); openCart(); cb && cb(); }).catch(function () { cb && cb(); });
  };
  $$('[data-atc-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[type=submit]', form), id = $('[name=id]', form).value, qi = $('[name=quantity]', form);
      var qty = qi ? +qi.value || 1 : 1;
      if (btn) { btn.dataset.t = btn.textContent; btn.textContent = (S.adding || 'Adding…'); btn.disabled = true; }
      window.NATIVA_add(id, qty, function () { if (btn) { btn.textContent = btn.dataset.t; btn.disabled = false; } });
    });
  });
  $$('[data-quick-add]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); window.NATIVA_add(b.getAttribute('data-quick-add'), 1); }); });
  refresh();

  /* ---------- qty steppers (PDP) ---------- */
  $$('[data-qty]').forEach(function (q) {
    var input = $('input', q);
    var inc = $('[data-inc]', q), dec = $('[data-dec]', q);
    inc && inc.addEventListener('click', function () { input.value = +input.value + 1; });
    dec && dec.addEventListener('click', function () { input.value = Math.max(1, +input.value - 1); });
  });

  /* ---------- variants ---------- */
  $$('[data-variant-picker]').forEach(function (picker) {
    var data = JSON.parse($('[data-variant-json]', picker).textContent);
    var form = picker.closest('form'), idField = $('[name=id]', form);
    var priceEl = $('[data-pdp-price]'), atc = $('[data-atc-btn]', form);
    function upd() {
      var chosen = $$('input:checked', picker).map(function (i) { return i.value; });
      var m = data.find(function (v) { return v.options.join('~') === chosen.join('~'); });
      if (m) { idField.value = m.id; if (priceEl) priceEl.textContent = money(m.price); if (atc) { atc.disabled = !m.available; atc.textContent = m.available ? (atc.dataset.t || S.addToCart || 'Add to cart') : (S.soldOut || 'Sold out'); } var bn = document.querySelector('[data-buy-now-pdp]'); if (bn) { bn.style.opacity = m.available ? '' : '.5'; bn.style.pointerEvents = m.available ? '' : 'none'; } }
    }
    $$('input', picker).forEach(function (i) { i.addEventListener('change', upd); }); upd();
  });

  /* ---------- gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main] img', g), box = $('[data-gallery-main]', g);
    $$('[data-gallery-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-full'); main.alt = t.getAttribute('data-alt') || '';
        $$('[data-gallery-thumb]', g).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
    box && box.addEventListener('click', function () { box.classList.toggle('zoom'); });
    box && box.addEventListener('mousemove', function (e) {
      if (!box.classList.contains('zoom')) return;
      var r = box.getBoundingClientRect();
      main.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
  });

  /* ---------- sticky ATC ---------- */
  var st = $('.sticky-atc'), anchor = $('[data-buy-anchor]');
  if (st && anchor) { new IntersectionObserver(function (e) { st.classList.toggle('show', !e[0].isIntersecting); }, { threshold: 0 }).observe(anchor); }

  /* ---------- filters + sort ---------- */
  $$('[data-filter]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var val = chip.getAttribute('data-filter'), grp = chip.closest('.filters');
      $$('[data-filter]', grp).forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      $$('[data-product-tags]').forEach(function (card) {
        var tags = (card.getAttribute('data-product-tags') || '').split(',');
        card.style.display = (val === 'all' || tags.indexOf(val) > -1) ? '' : 'none';
      });
    });
  });
  var sortSel = $('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var grid = $('[data-product-grid]'); if (!grid) return;
    var cards = $$('[data-product-tags]', grid), v = sortSel.value;
    cards.sort(function (a, b) {
      if (v === 'price-asc') return a.dataset.price - b.dataset.price;
      if (v === 'price-desc') return b.dataset.price - a.dataset.price;
      if (v === 'title') return a.dataset.title.localeCompare(b.dataset.title);
      return 0;
    });
    cards.forEach(function (c) { grid.appendChild(c); });
  });

  /* ---------- predictive search ---------- */
  var si = $('[data-predictive-input]'), sr = $('[data-predictive-results]');
  if (si && sr) {
    var tt;
    si.addEventListener('input', function () {
      clearTimeout(tt); var q = si.value.trim();
      if (q.length < 2) { sr.innerHTML = ''; sr.hidden = true; return; }
      sr.hidden = false;
      sr.innerHTML = '<div class="skeleton" style="height:16px;margin:.4rem 0"></div><div class="skeleton" style="height:16px;width:70%"></div>';
      tt = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6')
          .then(function (r) { return r.json(); }).then(function (d) {
            var p = d.resources.results.products || [], c = d.resources.results.collections || [];
            if (!p.length && !c.length) { sr.innerHTML = '<div class="muted" style="padding:.6rem">' + (S.noMatches || 'No matches.') + '</div>'; return; }
            sr.innerHTML =
              (c.length ? c.map(function (x) { return '<a href="' + x.url + '" style="display:block;padding:.5rem;font-weight:600">' + x.title + '</a>'; }).join('') : '') +
              (p.length ? p.map(function (x) { return '<a href="' + x.url + '" style="display:block;padding:.5rem;color:var(--muted)">' + x.title + '</a>'; }).join('') : '');
          }).catch(function () {});
      }, 220);
    });
    document.addEventListener('click', function (e) { if (!sr.contains(e.target) && e.target !== si) sr.hidden = true; });
  }

  /* ---------- wishlist + recently viewed (localStorage placeholders) ---------- */
  var wish = []; try { wish = JSON.parse(localStorage.getItem('nativa_wish') || '[]'); } catch (e) {}
  function paintWish() { $$('[data-wish]').forEach(function (b) { b.classList.toggle('active', wish.indexOf(b.getAttribute('data-wish')) > -1); }); }
  $$('[data-wish]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var id = b.getAttribute('data-wish');
      wish = wish.indexOf(id) > -1 ? wish.filter(function (x) { return x !== id; }) : wish.concat(id);
      try { localStorage.setItem('nativa_wish', JSON.stringify(wish)); } catch (e) {}
      paintWish();
    });
  });
  paintWish();
  var rv = document.body.getAttribute('data-product-handle');
  if (rv) { var a = []; try { a = JSON.parse(localStorage.getItem('nativa_rv') || '[]'); } catch (e) {} a = [rv].concat(a.filter(function (x) { return x !== rv; })).slice(0, 8); try { localStorage.setItem('nativa_rv', JSON.stringify(a)); } catch (e) {} }
})();

/* ---------- native product recommendations (Section Rendering API) ---------- */
(function(){
  document.querySelectorAll('[data-recommendations]').forEach(function(el){
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function(r){ return r.text(); }).then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim().length) {
        el.innerHTML = inner.innerHTML;
        if (window.NATIVA_bindReveal) window.NATIVA_bindReveal(el);
      }
    }).catch(function(){});
  });
})();

/* ---------- Buy Now (PDP): always uses the currently selected variant + quantity ---------- */
(function () {
  var bn = document.querySelector('[data-buy-now-pdp]');
  if (!bn) return;
  bn.addEventListener('click', function (e) {
    e.preventDefault();
    var form = document.querySelector('[data-atc-form]') || document.querySelector('form[action*="/cart/add"]');
    var id = form && form.querySelector('input[name="id"]') ? form.querySelector('input[name="id"]').value : null;
    var qtyEl = form && form.querySelector('input[name="quantity"]');
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
    if (id) window.location.href = (window.NATIVA && NATIVA.cartUrl ? NATIVA.cartUrl : '/cart') + '/' + id + ':' + qty;
  });
})();
